import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import ptBR from '../locales/pt-BR/translation.json';
import en from '../locales/en/translation.json';
import es from '../locales/es/translation.json';

i18next
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetector)
  .init({
    interpolation: {
      escapeValue: false,
    },

    lng: 'en',

    fallbackLng: 'en',

    debug: false,

    resources: {
      en:    { translation: en },
      es:    { translation: es },
      'pt-BR': { translation: ptBR },
    },

    detection: {
      order: ['querystring', 'cookie', 'localStorage'],

      lookupQuerystring: 'lang',
      lookupCookie: process.env.REACT_APP_LANGUAGE_CACHE_KEY || 'lang',
      lookupLocalStorage: process.env.REACT_APP_LANGUAGE_CACHE_KEY || 'lang',

      caches: [],
      excludeCacheFor: ['cimode'],

      checkWhitelist: true,
    },

    whitelist: ['en', 'es', 'pt-BR'],
  })
  .then(() => {});

export default i18next;
